/* MASTERPIECE — display-only product title cleanup (PDP, cart drawer, cart page, product links).
   Strips emojis and the " | extra keywords" tail from what shoppers see. Product data, SEO titles and feeds are untouched.
   Also loads mpx-cards.js (card photo dots + sizes styles). mpx-cart-boost.js is retired (Oct 2026) and no longer requested. */
(function () {
  'use strict';
  var d = document;

  /* load sibling assets from the same folder */
  var cs = d.currentScript;
  if (cs && cs.src) {
    ['mpx-cards.js'].forEach(function (f) {
      if (d.querySelector('script[data-mpx-asset="' + f + '"]')) return;
      var sb = d.createElement('script');
      sb.src = cs.src.replace('mpx-titles.js', f);
      sb.defer = true; sb.setAttribute('data-mpx-asset', f);
      d.head.appendChild(sb);
    });
  }

  var EMOJI = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}\u{20E3}\u{1F1E6}-\u{1F1FF}]/gu;
  var HAS = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}]/u;
  var SEL = [
    'h1',
    'a[href*="/products/"]',
    '[class*="product-title"]', '[class*="product__title"]', '[class*="product-name"]', '[class*="product__name"]',
    '[class*="cart-item"] [class*="title"]', '[class*="cart-item"] [class*="name"]',
    'cart-drawer [class*="title"]', 'cart-items [class*="title"]', 'sticky-buy-button [class*="title"]'
  ].join(',');

  function tidy(v) {
    var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0];
    var core = v.replace(EMOJI, '').split(/\s\|\s/)[0]
      .replace(/\s{2,}/g, ' ')
      .replace(/^[\s\-–|·]+|[\s\-–|·]+$/g, '');
    return core ? lead + core + trail : lead + trail;
  }

  function run(root) {
    root = root || d.body;
    if (!root || !root.querySelectorAll) return;
    var els = [];
    if (root.matches && root.matches(SEL)) els.push(root);
    Array.prototype.push.apply(els, root.querySelectorAll(SEL));
    els.forEach(function (el) {
      if (el.closest('script,style,textarea,[contenteditable],.mpx-search__input')) return;
      var w = d.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (!HAS.test(v) && v.indexOf(' | ') < 0) continue;
        var nv = tidy(v);
        if (nv !== v) n.nodeValue = nv;
      }
    });
  }

  /* cart drawers, quick views and variant changes re-render markup — clean whatever gets added */
  var pending = [], queued = false;
  function flush() {
    queued = false;
    var roots = pending; pending = [];
    roots.forEach(function (r) { if (r.isConnected) run(r); });
  }
  function watch() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) pending.push(node);
          else if (node.nodeType === 3 && node.parentElement) pending.push(node.parentElement);
        });
      });
      if (pending.length && !queued) { queued = true; requestAnimationFrame(flush); }
    }).observe(d.body, { childList: true, subtree: true });
  }

  function boot() { run(); watch(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
